"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _UIConfirmDialog = _interopRequireDefault(require("./UIConfirmDialog"));

var _UIModal = _interopRequireDefault(require("./UIModal"));

var UIConfirmModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIConfirmModal, _Component);

  function UIConfirmModal() {
    (0, _classCallCheck2.default)(this, UIConfirmModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIConfirmModal).apply(this, arguments));
  }

  (0, _createClass2.default)(UIConfirmModal, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIModal.default, Object.assign({}, this.props, {
        ModalDialog: _UIConfirmDialog.default
      }));
    }
  }]);
  return UIConfirmModal;
}(_react.Component);

exports.default = UIConfirmModal;
UIConfirmModal.displayName = 'UIConfirmModal';
UIConfirmModal.propTypes = Object.assign({}, _UIConfirmDialog.default.propTypes, {
  _contextual: _propTypes.default.bool
});
UIConfirmModal.defaultProps = Object.assign({}, _UIConfirmDialog.default.defaultProps, {
  onReject: _emptyFunction.default,
  _contextual: false
});
UIConfirmModal.contextTypes = {
  sandboxed: _propTypes.default.bool
};
module.exports = exports.default;